import { UseFormRegister, FieldValues, Path, FieldErrors, RegisterOptions } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Input } from "./Input";
import { emailRegex } from "../validation";
import { translationKey } from "../i18n";

export const EmailInput = <TFIeldValues extends FieldValues, TProperty extends Path<TFIeldValues>>({
	register,
	name,
	errors,
	label,
	placeholder,
	registerOptions,
	required = false,
	...rest
}: {
	register: UseFormRegister<TFIeldValues>;
	name: TProperty;
	errors: FieldErrors<TFIeldValues>;
	label: translationKey;
	placeholder?: translationKey;
	registerOptions?: RegisterOptions<TFIeldValues, TProperty>;
	required?: boolean;
}) => {
	const { t } = useTranslation();

	return (
		<Input
			register={register}
			name={name}
			errors={errors}
			label={label}
			placeholder={placeholder}
			inputType="email"
			required={required}
			registerOptions={{
				...((required || registerOptions?.required) && {
					pattern: {
						value: emailRegex,
						message: t("invalidEmail")
					}
				}),
				...registerOptions,
				valueAsNumber: false,
				valueAsDate: false
			}}
			{...rest}
		/>
	);
};
